import { Empty, PageHeader, Popconfirm, Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { TableItem, ButtonItem } from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import { CheckCircleOutlined, EditOutlined, StopOutlined } from "@ant-design/icons";
import AgregarCanal from "./AgregarCanalVenta/AgregarCanalVenta";
import EditarCanal from "./EditarCanalVenta/EditarCanalVenta";

moment.locale("es");

class CanalesVenta extends Component {
  state = {
    modalAgregar: false,
    modalEditar: false,
    todosCanales: [],
    loading: false,
    canalSeleccionado: null,
  };

  // Abrir modal para agregar
  abrirAgregarCanal = () => {
    this.setState({ modalAgregar: true, canalSeleccionado: null });
  };

  // Cerrar modal de agregar
  cerrarAgregarCanal = () => {
    this.setState({ modalAgregar: false });
    this.consultarTodosCanales();
  };

  // Abrir modal para editar
  abrirEditarCanal = (canal) => {
    this.setState({ modalEditar: true, canalSeleccionado: canal });
  };

  // Cerrar modal de editar
  cerrarEditarCanal = () => {
    this.setState({ modalEditar: false });
    this.consultarTodosCanales();
  };

  componentDidMount() {
    this.consultarTodosCanales();
  }

  consultarTodosCanales() {
    this.setState({ loading: true });
    axios
      .post(
        "canalesVenta/selectTodosCanalesVenta",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.status === 404) {
          message.error("No se encontraron canales");
        } else {
          this.setState({
            todosCanales: res.data.canalesVenta.map((value) => {
              return { ...value, accion: { _id: value._id, estado: value.estado } };
            }),
          });
        }
      });
  }

  // Deshabilita un canal
  deshabilitarCanal(id) {
    axios
      .post(
        "canalesVenta/deshabilitarCanalVenta",
        { canalId: id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Canal deshabilitado exitosamente");
          this.consultarTodosCanales();
        } else if (res.data.success === 1){
          message.error("Error al deshabilitar el canal");
        } else {
          message.error("Error");
        }
      });
  }

  // Habilita un canal
  habilitarCanal(id) {
    axios
      .post(
        "canalesVenta/habilitarCanalVenta",
        { canalId: id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Canal habilitado exitosamente");
          this.consultarTodosCanales();
        } else if (res.data.success === 1){
          message.error("Error al habilitar el canal");
        } else {
          message.error("Error");
        }
      });
  }

  render() {
    const columns = [
      {
        title: "Código",
        dataIndex: "codigo",
        key: "codigo",
        sorter: (a, b) => a.codigo.localeCompare(b.codigo),
        width: "16%",
        ellipsis: true,
      },
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        sorter: (a, b) => a.nombre.localeCompare(b.nombre),
        width: "20%",
        ellipsis: true,
      },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
        sorter: (a, b) => a.descripcion.localeCompare(b.descripcion),
        width: "20%",
        ellipsis: true,
      },
      {
        title: "Acción",
        key: "accion",
        align: "center",
        width: "16%",
        onCell: () => ({
          className: "acciones-sin-hover"
        }),
        render: (record) => {
          let buttons = [];

          buttons.push(
            <Tooltip title="Editar" placement="top" key={`edit-${record._id}`}>
              <ButtonItem
                type="default"
                size="small"
                cyan
                icon={<EditOutlined />}
                onClick={() => this.abrirEditarCanal(record)}
              >
              </ButtonItem>
            </Tooltip>
          );

          if (record.estado === 1) {
            buttons.push(
              <Popconfirm
                key={`deshabilitar-${record._id}`}
                title="¿Seguro que quieres deshabilitar este canal?"
                onConfirm={() => this.deshabilitarCanal(record._id)}
                okText="Sí"
                cancelText="No"
              >
                <Tooltip title="Deshabilitar" placement="top">
                  <ButtonItem
                    type="default"
                    size="small"
                    lima
                    icon={<CheckCircleOutlined />}
                  >
                  </ButtonItem>
                </Tooltip>
              </Popconfirm>
            );
          } else {
            buttons.push(
              <Popconfirm
                key={`habilitar-${record._id}`}
                title="¿Seguro que quieres habilitar este canal?"
                onConfirm={() => this.habilitarCanal(record._id)}
                okText="Sí"
                cancelText="No"
              >
                <Tooltip title="Habilitar" placement="top">
                  <ButtonItem
                    type="default"
                    size="small"
                    rojo
                    icon={<StopOutlined />}
                  >
                  </ButtonItem>
                </Tooltip>
              </Popconfirm>
            );
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];

    return (
      <>
        <PageHeader
          title="Canales"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <ButtonItem
              type="primary"
              key="agregarCanal"
              onClick={this.abrirAgregarCanal}
              olivo
              className="btnHeader" 
               style={{ fontSize: '14px', padding: '6.4px 15px', height: '32px' }}
            >
              Agregar Canal
            </ButtonItem>
          }
        />
        <TableItem
          locale={{
            emptyText: (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={
                  <>
                    <p>No hay registros de canales. Aquí puedes gestionar y llevar un control de los canales.</p>
                  </>
                }
              />
            ),
          }}
          loading={this.state.loading}
          size="small"
          dataSource={this.state.todosCanales}
          columns={columns}
          pagination={false}
        />
        <AgregarCanal
          visible={this.state.modalAgregar}
          cerrarModal={this.cerrarAgregarCanal}
          canal={this.state.canalSeleccionado}
        />
        <EditarCanal
          visible={this.state.modalEditar}
          cerrarModal={this.cerrarEditarCanal}
          canal={this.state.canalSeleccionado}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(CanalesVenta);
